import { render, staticRenderFns } from "@/style-guide/partials/checkbox/checkbox.pug?vue&type=template&id=515d5bc4&scoped=true&lang=pug&external"
import script from "./checkbox.vue?vue&type=script&lang=ts"
export * from "./checkbox.vue?vue&type=script&lang=ts"
import style0 from "./checkbox.vue?vue&type=style&index=0&id=515d5bc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515d5bc4",
  null
  
)

export default component.exports